import { giphyBlack, giphyGreen, giphyIndigo } from '@giphy/js-brand'
import styled, { css, keyframes } from 'styled-components'
import { MARGIN } from '../../constants'

export const fadeOutTime = 200
export const Container = styled.div<{ isVisible: boolean; isStickerGrid: boolean; appWidth: number }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    opacity: ${(props) => (props.isVisible ? 1 : 0)};
    ${(props) =>
        !props.isVisible &&
        css`
            pointer-events: none;
        `};
    transition: opacity ${fadeOutTime}ms ease-out;
    background: ${giphyBlack};
    margin-top: -${MARGIN}px;
    padding: ${MARGIN}px;
    /* the nav has its own padding top */
    padding-bottom: 0;
    ${(props) =>
        props.isStickerGrid &&
        css`
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC');
            background-size: ${props.appWidth / 10}px;
        `}

    &:before {
        background: linear-gradient(360deg, ${giphyBlack}, rgba(0, 0, 0, 0));
        content: '';
        position: absolute;
        left: -100px;
        height: 50px;
        right: -100px;
        bottom: 0;
        pointer-events: none;
    }
`

const attributionHeight = 42
export const AttributionContainer = styled.div`
    display: flex;
    height: ${attributionHeight}px;
    justify-content: flex-end;
    align-items: center;
    position: relative;
`

export const buttonWidth = 40

export const Instructions = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    padding: ${MARGIN};
    padding-bottom: 0;
    b {
        font-weight: 600;
    }
    img {
        margin-right: 4px;
    }
`
export const ClipTips = styled.div`
    text-align: center;
    svg {
        vertical-align: middle;
    }
`

export const Back = styled.img`
    height: 22px;
    cursor: pointer;
    position: absolute;
    left: 0;
`

export const GifContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: none;
    flex-direction: column;
    position: relative;
    margin-bottom: ${MARGIN}px;
    img {
        border-radius: 4px;
        overflow: hidden;
    }
`

export const DetailGifContainer = styled.div`
    position: relative;
`

export const Header = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    height: 25px;
    margin-bottom: 4px;
`

export const flash = keyframes`
  0% {
    background: ${giphyIndigo};
  }
  40% {
    background: ${giphyGreen};
    color: ${giphyBlack};
  }
  100% {
    background: ${giphyIndigo};
  }
`
export const CTAButton = styled.div<{ copiedAnimation: boolean }>`
    background: ${giphyIndigo};
    width: ${attributionHeight}px;
    height: ${attributionHeight}px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    cursor: pointer;
    margin-left: 4px;
    ${(props) =>
        props.copiedAnimation &&
        css`
            animation: ${flash} 500ms forwards;
        `}
`
